import { uniqueId } from "@/views/zhiji/js/common/util.js";
import { ParamError } from "@/views/zhiji/js/common/errors.js";
import i18n from "@/i18n";

export default {
    widgetName: "Form",
    serverType: "form",
    initContent() {
        return {
            uId: uniqueId(),
            updateState: "add",
            wtType: "Form",
            title: ""
        };
    },
    checkContent(content) {
        if (!content.formId || content.formId == "def") {
            throw new ParamError(i18n.t("zhiji.answer.selectFormType"));
        }
    },
    server2Client(content) {
        return {
            uId: uniqueId(),
            wtType: "Form",
            title: "",
            formId: content.form_id,
            updateState: "add",
            formName: content.form_name
        };
    },
    client2Server(content) {
        return {
            type: "form",
            title: "",
            form_id: content.formId,
            form_name: content.formName
        };
    }
};
